import request from '@/utils/admin/request'

export function getProductTag() {
    return request({
        url: '/c/product/tag',
        method: 'get',
    });
}

export function setProductTag(data) {
    return request({
        url: '/c/product/tag',
        method: 'post',
        data: data
    });
}

export function getProductInfo(productId) {
    return request({
        url: '/yxStoreProduct/info/' + productId,
        method: 'get',
    });
}

